import React from 'react';
import { OverlayProvider, RootThemeProvider } from '@direct-frontend/components';
import { ToastContainer } from '@adv-frontend/toast';
import { yastoreDarkTheme, yastoreLightTheme } from '@/shared/lib/themekit';
import { Routes } from '../Routes';
import './Application.css';
import './media.css';

const ROOT_STYLES = { height: '100%' };

export const Application = () => (
    <RootThemeProvider theme={yastoreLightTheme}>
        <OverlayProvider style={ROOT_STYLES}>
            <RootThemeProvider theme={yastoreDarkTheme}>
                <ToastContainer />
            </RootThemeProvider>
            <Routes />
        </OverlayProvider>
    </RootThemeProvider>
);
